// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.not-found-page-container {
  display: flex;
  justify-content: center;
  height: 90vh;
}
.oops-page-text-header {
  font-family: Roboto;
  font-weight: 700;
  font-style: Bold;
  font-size: 36px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: center;
  color: #000000;
}
.page-not-found-paragraph-text {
  font-family: Roboto;
  font-weight: 400;
  font-style: Regular;
  font-size: 23px;
  line-height: 32.2px;
  letter-spacing: 0%;
  text-align: center;
  color: #5d5d5d;
}
.main {
  display: flex;
  flex-direction: column;
  width: 50%;
  justify-content: center;
  align-items: center;
}
.oops-page-text-header-row {
  margin-top: 50px;
}
.page-not-found-paragraph-row {
  width: 70%;
  margin-top: 10px;
}
.go-back-page-not-button {
  margin-top: 20px;
}
.not-found-image {
  width: 100% !important;
  height: 100% !important;
}
@media (min-width: 769px) and (max-width: 1024px) {
  .main {
    width: 100%;
  }
  .not-found-image {
    width: 90% !important;
    height: 90% !important;
  }
  .oops-page-text-header-row {
    margin-top: 20px !important;
  }
}
@media (min-width: 426px) and (max-width: 768px) {
  .main {
    width: 70% !important;
  }
}
@media (min-width: 0px) and (max-width: 425px) {
  .main {
    width: 100% !important;
    padding: 20px !important;
  }
  .page-not-found-paragraph-row {
    width: 100% !important;
  }
  .oops-page-text-header {
    font-size: 20px !important;
  }
  .page-not-found-paragraph-text {
    font-size: 18px !important;
    line-height: 24.2px !important;
  }
  .oops-page-text-header-row {
    margin-top: 30px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/error-handling-page/NotFoundPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE;IACE,WAAW;EACb;EACA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;EACA;IACE,2BAA2B;EAC7B;AACF;AACA;EACE;IACE,qBAAqB;EACvB;AACF;AACA;EACE;IACE,sBAAsB;IACtB,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;IAC1B,8BAA8B;EAChC;EACA;IACE,2BAA2B;EAC7B;AACF","sourcesContent":[".not-found-page-container {\n  display: flex;\n  justify-content: center;\n  height: 90vh;\n}\n.oops-page-text-header {\n  font-family: Roboto;\n  font-weight: 700;\n  font-style: Bold;\n  font-size: 36px;\n  line-height: 100%;\n  letter-spacing: 0%;\n  text-align: center;\n  color: #000000;\n}\n.page-not-found-paragraph-text {\n  font-family: Roboto;\n  font-weight: 400;\n  font-style: Regular;\n  font-size: 23px;\n  line-height: 32.2px;\n  letter-spacing: 0%;\n  text-align: center;\n  color: #5d5d5d;\n}\n.main {\n  display: flex;\n  flex-direction: column;\n  width: 50%;\n  justify-content: center;\n  align-items: center;\n}\n.oops-page-text-header-row {\n  margin-top: 50px;\n}\n.page-not-found-paragraph-row {\n  width: 70%;\n  margin-top: 10px;\n}\n.go-back-page-not-button {\n  margin-top: 20px;\n}\n.not-found-image {\n  width: 100% !important;\n  height: 100% !important;\n}\n@media (min-width: 769px) and (max-width: 1024px) {\n  .main {\n    width: 100%;\n  }\n  .not-found-image {\n    width: 90% !important;\n    height: 90% !important;\n  }\n  .oops-page-text-header-row {\n    margin-top: 20px !important;\n  }\n}\n@media (min-width: 426px) and (max-width: 768px) {\n  .main {\n    width: 70% !important;\n  }\n}\n@media (min-width: 0px) and (max-width: 425px) {\n  .main {\n    width: 100% !important;\n    padding: 20px !important;\n  }\n  .page-not-found-paragraph-row {\n    width: 100% !important;\n  }\n  .oops-page-text-header {\n    font-size: 20px !important;\n  }\n  .page-not-found-paragraph-text {\n    font-size: 18px !important;\n    line-height: 24.2px !important;\n  }\n  .oops-page-text-header-row {\n    margin-top: 30px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
